import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m24.118 12.318-8.813-8.814-8.814 8.814 2.121 2.121 5.193-5.193v33.129h3V9.246l5.192 5.193zm15.27 12.089L34.195 29.6V16.355h-3V29.6l-5.192-5.193-2.121 2.121 8.813 8.814 8.814-8.814z" }) }) })
});
export default SvgSortUp;
